import { render } from "./SelecionarTipoCadastro.vue?vue&type=template&id=10d0b432&scoped=true"
import script from "./SelecionarTipoCadastro.vue?vue&type=script&lang=js"
export * from "./SelecionarTipoCadastro.vue?vue&type=script&lang=js"

import "./SelecionarTipoCadastro.vue?vue&type=style&index=0&id=10d0b432&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d0b432"]])

export default __exports__